import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useParams, useLocation, Link, Redirect } from 'react-router-dom';
import { ADAWidgitRoles } from '../../../models/ADA';

import './InnovationNested.scss';

import DetailExpander from '../subcomponents/DetailExpander/DetailExpander';

const wholeTransitionDuration = 0.5; // Must be the same as in CSS
const transitionModes = { // Must match the CSS classes
  WHOLE: 'whole',
  PARTIAL: 'partial'
};

const InnovationNested = ({ topic, linkToMain, linkToNext, nextTitle, topOffset, bubbleLabels, nestedParamHandler, onMobile, onClose }) => {
  const { innovationId } = useParams();
  const { hash } = useLocation();
  const [activeKey, setActiveKey] = useState(null);
  const [transitionClass, setTransitionClass] = useState('');
  const [transitionMode, setTransitionMode] = useState(transitionModes.WHOLE);
  const [redirectTo, setRedirectTo] = useState(null);
  const [wrapperParams, setWrapperParams] = useState(null);
  const [closeParams, setCloseParams] = useState(null);
  const refWrapper = useRef(null);
  const refClose = useRef(null);

  useEffect(() => {
    nestedParamHandler(innovationId);
  }, [innovationId]);

  useEffect(() => {
    setRedirectTo(null);

    if (!topic) {
      setActiveKey(null);
      return;
    }

    let targetActiveKey = topic.Overview.Key;
    if (hash) {
      switch (hash.replace('#', '').toLowerCase()) {
        case bubbleLabels.Origin.toLowerCase():
          targetActiveKey = topic.Origin.Key;
          break;
        case bubbleLabels.Context.toLowerCase():
          targetActiveKey = topic.Context.Key;
          break;
        case bubbleLabels.Impact.toLowerCase():
          targetActiveKey = topic.Impact.Key;
          break;
        case bubbleLabels.Future.toLowerCase():
          targetActiveKey = topic.Future.Key;
          break;
        default:
          break;
      }
    }
    setActiveKey(targetActiveKey);
  }, [topic]);

  useLayoutEffect(() => {
    //setTransitionClass('entering');
    setTimeout(() => {
      setTransitionClass('');
      setTransitionMode(transitionModes.WHOLE);
    }, wholeTransitionDuration * 1000);
  }, [topic]);

  const handleResize = () => {
    if (refWrapper.current && refClose.current) {
      setWrapperParams(refWrapper.current.getBoundingClientRect());
      setCloseParams(refClose.current.getBoundingClientRect());
    } else {
      setTimeout(() => {
        handleResize();
      }, 1);
    }
  };

  useLayoutEffect(() => {

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleRedirection = (event, to, mode) => {
    event.preventDefault();

    let objs = null;
    
    if(document.getElementsByClassName('innovation-nv-up-next-text').length > 0)
    {
      objs = document.getElementsByClassName('innovation-detail-expander');
    }
    
    setTransitionClass('exiting');
    setTransitionMode(mode === transitionModes.PARTIAL ? transitionModes.PARTIAL : transitionModes.WHOLE);

    if(objs != null && objs.length > 0)
    {
      for(let i = 0; i < objs.length; i++)
      {
        objs[i].style.opacity = 0;
        objs[i].style.transition = "opacity 0.3s ease 0.3s"
      }
    }
    //setRedirectTo(to);
    
    setTimeout(() => {
      setRedirectTo(to);
      setTimeout(() => {
        if(objs != null && objs.length > 0)
        {
          for(let i = 0; i < objs.length; i++)
          { 
            objs[i].style.transition = "width 0s ease 0s";
            objs[i].style.opacity = 1;
            objs[i].style.transition = "opacity 0.3s ease 0.3s";

            setTimeout(() => {
                objs[i].style.transition = "width 0.5s ease 0.25s";
            }, wholeTransitionDuration * 1000);
          }
        }
    }, wholeTransitionDuration * 1000);

    }, wholeTransitionDuration * 1000);

    const element = event.target;

  }

  if (!topic) return null;

  return (
    <div className={`innovation-nested-view ${transitionClass}-${transitionMode}`} aria-haspopup="dialog" style={{ top: `${topOffset}px` }}>
      <div className="innovation-nv-fixed-bg"/>
      <div className='innovation-nv-center-wrapper' ref={refWrapper}>
        <div className='innovation-nv-center'>
          <div className='innovation-nv-elements-wrapper'>
            <DetailExpander
              data={topic.Origin.DetailedView}
              isActive={activeKey === topic.Origin.Key}
              activityHandler={() => {setActiveKey(topic.Origin.Key); }}
              icon={onMobile ? 'prev' : (activeKey === topic.Origin.Key ? '' : 'prev')}
              label={bubbleLabels.Origin}
              wrapperParams={wrapperParams}
              closeParams={closeParams}
              onMobile={onMobile}
            />
            <DetailExpander
              data={topic.Context.DetailedView}
              isActive={activeKey === topic.Context.Key}
              activityHandler={() => setActiveKey(topic.Context.Key)}
              icon={onMobile ? 'rw' : (activeKey === topic.Context.Key ? '' : activeKey === topic.Origin.Key ? 'ff': 'rw')}
              label={bubbleLabels.Context}
              wrapperParams={wrapperParams}
              closeParams={closeParams}
              onMobile={onMobile}
            />
            <DetailExpander
              data={topic.Overview.DetailedView}
              isActive={activeKey === topic.Overview.Key}
              activityHandler={() => setActiveKey(topic.Overview.Key)}
              icon={onMobile ? 'play' : (activeKey === topic.Overview.Key ? '' : (activeKey === topic.Origin.Key || activeKey === topic.Context.Key) ? 'ff': 'rw')}
              label={bubbleLabels.Overview}
              wrapperParams={wrapperParams}
              closeParams={closeParams}
              onMobile={onMobile}
            />
            <DetailExpander
              data={topic.Impact.DetailedView}
              isActive={activeKey === topic.Impact.Key}
              activityHandler={() => setActiveKey(topic.Impact.Key)}
              icon={onMobile ? 'ff' : (activeKey === topic.Impact.Key ? '' : activeKey === topic.Future.Key ? 'rw': 'ff')}
              label={bubbleLabels.Impact}
              wrapperParams={wrapperParams}
              closeParams={closeParams}
              onMobile={onMobile}
            />
            <DetailExpander
              data={topic.Future.DetailedView}
              isActive={activeKey === topic.Future.Key}
              activityHandler={() => setActiveKey(topic.Future.Key)}
              icon={onMobile ? 'next' : (activeKey === topic.Future.Key ? '' : 'next')}
              label={bubbleLabels.Future}
              wrapperParams={wrapperParams}
              closeParams={closeParams}
              onMobile={onMobile}
            />
          </div>
        </div>
        {/* <Link aria-hidden={true} className='innovation-nv-close' to={linkToMain} ref={refClose} /> */}
        <button role={ADAWidgitRoles.Button} aria-label="close" className='innovation-nv-close' href={linkToMain} ref={refClose} onClick={(event) => {handleRedirection(event, linkToMain, transitionModes.WHOLE); onClose();}} />
      </div>
      {
        linkToNext
        &&
        <div className='innovation-nv-bottom-nav'>
          <div className="innovation-nv-bottom-nav-inner">
            <div className='innovation-nv-caret'/>
            <div className='innovation-nv-up-next-text'>Up Next: {nextTitle}</div>
            {/* <Link aria-hidden={true} className='innovation-nv-next' to={linkToNext} /> */}
            <button role={ADAWidgitRoles.Button} aria-label={"Up Next: " + nextTitle} className='innovation-nv-next' href={linkToNext} onClick={(event) => handleRedirection(event, linkToNext, transitionModes.PARTIAL)} />
          </div>
        </div>
      }
      { redirectTo && <Redirect to={redirectTo} /> }
    </div>
  );
};

export default InnovationNested;